import React from 'react';
import { useFlips } from '../hooks/useFlips';
import formatNumber from '../utils/formatNumber';

function FlipsTokenDetail() {
  const { choiceOfToken, getChoiceOfTokenName, tokenTotals, maxBet } = useFlips();

  return (
    <div className='flex flex-col gap-3 w-full md:w-auto'>
      <p className='text-gray-400 text-center font-bold text-lg'>
        Selected: {getChoiceOfTokenName(choiceOfToken)}{' '}
        <a href={`https://explorer.perawallet.app/asset/${choiceOfToken}`} className='text-primary-500' target='_blank'>
          {choiceOfToken}
        </a>
      </p>

      <div className='flex md:items-center md:flex-row flex-col gap-4 md:justify-center'>
        <div className='border-2 rounded-lg border-gray-700 p-3'>
          <p className='text-gray-500 text-sm'>Total in Flip wallet</p>
          <p className='text-white font-bold text-lg'>{formatNumber(tokenTotals.house || 0)}</p>
        </div>
        <div className='border-2 rounded-lg border-gray-700 p-3'>
          <p className='text-gray-500 text-sm'>Total in your wallet</p>
          <p className='text-white font-bold text-lg'>{formatNumber(tokenTotals.user || 0)}</p>
        </div>
        <div className='border-2 rounded-lg border-gray-700 p-3'>
          <p className='text-gray-500 text-sm'>Max Bet</p>
          <p className='text-white font-bold text-lg'>{formatNumber(maxBet || 0)}</p>
        </div>
      </div>
    </div>
  );
}

export default FlipsTokenDetail;
